import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../store/slices/authSlice';
import { Toast } from '../components/Toast';

function AuthCallback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let isMounted = true;

    const handleCallback = async () => {
      const token = searchParams.get('token');
      const needsOnboarding = searchParams.get('onboarding') === 'true';
      const error = searchParams.get('error');

      if (error) {
        if (isMounted) {
          Toast.error('Đăng nhập Google thất bại!');
          navigate('/login');
        }
        return;
      }

      if (!token) {
        if (isMounted) {
          Toast.error('Không nhận được token!');
          navigate('/login');
        }
        return;
      }

      try {
        // Fetch user data with token
        const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
        const response = await fetch(`${API_BASE_URL}/auth/google/success`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok && isMounted) {
          const userData = await response.json();
          
          // Save credentials to Redux
          dispatch(setCredentials({ 
            user: userData, 
            token: token 
          }));

          Toast.success('Đăng nhập thành công!');

          // Redirect về trang chủ luôn
          setTimeout(() => {
            navigate('/');
          }, 500);
        } else {
          throw new Error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        if (isMounted) {
          Toast.error('Có lỗi xảy ra!');
          navigate('/login');
        }
      }
    };

    handleCallback();

    return () => {
      isMounted = false;
    };
  }, [searchParams, navigate, dispatch]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-blue-200 dark:border-blue-900 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
        <p className="text-gray-600 dark:text-gray-400 font-medium">Đang xử lý đăng nhập...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
